/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerFindAllQueryResponse, DocumentsControllerFindAllQueryParams, DocumentsControllerFindAll401, DocumentsControllerFindAll403 } from "../../models/documentsController/DocumentsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentsControllerFindAll } from "../../clients/documentsService/documentsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentsControllerFindAllQueryKey = (params: DocumentsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/documents'
}, ...(params ? [params] : [])] as const;
export type DocumentsControllerFindAllQueryKey = ReturnType<typeof documentsControllerFindAllQueryKey>;
export function documentsControllerFindAllQueryOptions(params?: DocumentsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentsControllerFindAllQueryKey(params);
  return queryOptions<DocumentsControllerFindAllQueryResponse, ResponseErrorConfig<DocumentsControllerFindAll401 | DocumentsControllerFindAll403>, DocumentsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all documents
 * {@link /api/v1/documents}
 */
export function useDocumentsControllerFindAll<TData = DocumentsControllerFindAllQueryResponse, TQueryData = DocumentsControllerFindAllQueryResponse, TQueryKey extends QueryKey = DocumentsControllerFindAllQueryKey>(params?: DocumentsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<DocumentsControllerFindAllQueryResponse, ResponseErrorConfig<DocumentsControllerFindAll401 | DocumentsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...documentsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentsControllerFindAll401 | DocumentsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}